import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { CreateSupplierRequest } from '@nucleus-commerce/api-client/platform';

import { diamondsApi } from '../api/diamonds-api';

import { diamondKeys } from './diamond-keys';

/** Creates a supplier, or updates `supplierId` when given. */
export function useSaveSupplier(supplierId: string | null) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateSupplierRequest) =>
      supplierId
        ? diamondsApi.updateSupplier(supplierId, input)
        : diamondsApi.createSupplier(input),
    meta: {
      successMessage: supplierId
        ? 'diamonds:toasts.supplierSaved'
        : 'diamonds:toasts.supplierCreated',
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: diamondKeys.suppliers() }),
  });
}
